import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { ReferralService } from "../../../shared/service/referrer/referral.service";
import { combineLatest, Observable, of, switchMap } from "rxjs";

@Pipe({name: 'referrerTranslate', standalone: true, pure: true})
@Injectable({
  providedIn: 'root'
})
export class ReferrerTranslatePipe implements PipeTransform {

  constructor(private translocoService: TranslocoService,
              private referrerService: ReferralService) {}

  /**
   * This pipe is used to translate keys based on the referrer, if we are doing anything custom for the referrer.
   * To use this, please set the transloco key to be the same as the standard translation key but nested under the
   * `referrer` key.
   * e.g. if we have {home.title: welcome}, and we want to have a custom translation for the referrer `japanfoodie`
   * we will set the key to be `referrer.japanfoodie.home.title` and the value to be the custom message.
   *
   * This pipe will need to be marked with async pipe to be able to work.
   *
   * @param key
   * @param rootReferrerKey
   */

  transform(key: string, rootReferrerKey = "referrer"): Observable<string> {
    const standardTranslation$ = this.translocoService.selectTranslate(key);

    if (!this.referrerService?.getReferrerSlug()) {
      return standardTranslation$;
    }

    // Handle only Cathay and Singapore Airlines for now
    if (["cathaypacific", "sia"].includes(this.referrerService.getReferrerSlug())) {
      const referrerKey = `${rootReferrerKey}.${this.referrerService.getReferrerSlug()}.${key}`;
      const customTranslation$ = this.translocoService.selectTranslate(referrerKey);

      return combineLatest([customTranslation$, standardTranslation$]).pipe(
        switchMap(([custom, standard]) => {
          return of(custom && custom !== referrerKey ? custom : standard);
        })
      );
    }

    return standardTranslation$;
  }
}
